import React, { useEffect, useState } from "react";
import classes from "./HomePage.module.css";
import LinedSection from "../component/LinedSection";
import { fetchAndroidGamesApi, fetchGamesApi } from "../http/http";
import { FaStarOfLife, FaChevronDown } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Keyboard,
  EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { motion } from "framer-motion";
import LogoCarousel from "../component/LogoCarousel";
import TopGames from "../component/TopGames";
import Footer from "../component/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SectionHeading from "../component/SectionHeading";
import CategorySection from "../component/CategorySection";
import Games from "../component/Games";
import SectionTopUvPlayed from "../component/SectionTopUvPlayed";
import FooterCarousel from "../component/FooterCarousel";
import { useTranslation } from "react-i18next";
import { FaBars } from "react-icons/fa6";
import Drawer from "../component/Drawer";
import UnsubModal from "../component/UnsubModal";

const HomePage = () => {
  const [categories, setCategories] = useState([]);
  const [games, setGames] = useState([]);
  const [allGames, setAllGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popularGames, setPopularGames] = useState([]);
  const [topUvPlayedGames, setTopUvPlayedGames] = useState([]);
  const [categoryWiseGames, setCategoryWiseGames] = useState([]);
  const [androidGames, setAndroidGames] = useState([]);
  const [open, setOpen] = useState(false);
  const selectedLanguageId = Number(
    useSelector((state) => state?.persisted?.languageSlice?.language ?? 1),
  );
  const { user } = useSelector((state) => state?.persisted?.userSlice);
  const { unsubModal } = useSelector((state) => state?.unsubModalSlice);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const pickRandomK = (arr, k = 20) => {
    const n = Array.isArray(arr) ? arr.length : 0;
    if (n <= k) return arr ? [...arr] : [];

    const idx = new Set();
    while (idx.size < k) {
      idx.add(Math.floor(Math.random() * n));
    }
    return Array.from(idx, (i) => arr[i]);
  };

  const fetchGames = async (language) => {
    try {
      setLoading(true);
      const response = await fetchGamesApi(language);
      const response2 = await fetchAndroidGamesApi(language);
      setAndroidGames(response2?.data?.games);
      setAllGames(response?.data?.games);
      setGames(response?.data?.games);
      setCategories(response?.data?.categories);
      setPopularGames(pickRandomK(response?.data?.games, 5));
      setTopUvPlayedGames(pickRandomK(response?.data?.games, 5));

      const allGamesData = response?.data?.games || [];
      const categoriesData = response?.data?.categories || [];
      const androidGamesData = response2?.data?.games || [];

      setCategoryWiseGames(
        categoriesData.map((category) => ({
          category,
          games:
            String(category.category_type) === "all"
              ? allGamesData
              : String(category.category_type) === "android"
                ? androidGamesData
                : allGamesData.filter(
                    (game) => String(game.category_id) === String(category.id),
                  ),
        })),
      );
      setLoading(false);
    } catch (error) {
      console.log(error, "error--");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.token) {
      fetchGames(selectedLanguageId);
    } else {
      navigate("/subscribe");
    }
  }, [selectedLanguageId]);

  const renderSkeletonCards = (count, firstLarge = false) => {
    return Array.from({ length: count }).map((_, index) => {
      const isLarge = firstLarge && index === 0;

      return (
        <div
          key={`skeleton-${firstLarge ? "top" : "bottom"}-${index}`}
          className={`${classes.game_card} ${
            isLarge ? classes.large_card : classes.small_card
          } ${classes.skeletonCard}`}
        >
          <div className={classes.skeletonImage}></div>

          <div className={classes.skeletonContent}>
            <div className={classes.skeletonMetaRow}>
              <span className={classes.skeletonMeta}></span>
              <span className={classes.skeletonChip}></span>
            </div>

            <span
              className={`${classes.skeletonTitle} ${
                isLarge
                  ? classes.skeletonTitleLarge
                  : classes.skeletonTitleSmall
              }`}
            ></span>

            <span
              className={`${classes.skeletonTitle} ${
                isLarge
                  ? classes.skeletonTitleMedium
                  : classes.skeletonTitleTiny
              }`}
            ></span>
          </div>
        </div>
      );
    });
  };

  return (
    <main className={classes.main}>
      <section
        className={classes.heroSection}
        style={{
          backgroundImage: "url('/images/feature-bg.png')",
        }}
      >
        <LinedSection />

        <header className={classes.topBar}>
          <div className={classes.brand}>
            <div className={classes.brand_container}>
              <img
                src="/images/logo2.png"
                alt="uv gaming"
                className={classes.uv_logo}
                loading="lazy"
              />
              <div className={classes.brandSub}>{t("poweredBy")}</div>
            </div>
          </div>

          <button
            type="button"
            className={classes.menu_button}
            onClick={() => setOpen(true)}
          >
            <FaBars className={classes.menu_icon} />
          </button>

          {/* <div className={classes.topActions}>
            <button
              className={classes.btnGhost}
              onClick={() => navigate("/winners")}
            >
              {t("55")}
            </button>
            <button
              className={classes.btnGhost}
              onClick={() => navigate("/leaderboard")}
            >
              {t("56")}
            </button>
            <button
              className={classes.btnGhost}
              onClick={() => navigate("/profile")}
            >
              {t("57")}
            </button>
          </div> */}
        </header>

        <div className={classes.container}>
          <div className={classes.row}>
            {/* LEFT IMAGE */}
            <div className={`${classes.col} ${classes.colLeft}`}>
              <div
                className={`${classes.heroImageWrap} ${classes.slideInLeft}`}
              >
                <img
                  className={classes.heroImage}
                  src="/images/hero-section-vector-image.png"
                  alt="hero"
                  loading="lazy"
                />
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className={`${classes.col} ${classes.colRight}`}>
              <div className={classes.heroContent}>
                <h6 className={classes.subtitle}>{t("58")}</h6>

                <h1 className={classes.title}>
                  {t("59")} <br />
                  {t("60")}
                </h1>

                <p className={`${classes.desc} ${classes.fadeInUp}`}>
                  {t("61")}
                </p>

                <div
                  className={`${classes.btnRow} ${classes.fadeInUpDelay}`}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* Optional overlay for better contrast */}
        <div className={classes.overlay} />
      </section>

      <LogoCarousel />

      {loading ? (
        <>
          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <section className={classes.games_section}>
              {renderSkeletonCards(5, true)}
            </section>
          </section>
        </>
      ) : (
        <>
          <section className={classes.games_section_main}>
            <div className={classes.section_glow_left} />
            <div className={classes.section_glow_right} />

            <div className={classes.red_swoosh_container}>
              <img
                src="/images/red-swoosh.png"
                alt="red swoosh"
                className={classes.red_swoosh_img}
              />
            </div>
            <SectionHeading />
            <CategorySection categories={categories} />
          </section>
          {categoryWiseGames?.length > 0 && (
            <>
              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Adventure"
              />
              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Action"
              />
              <TopGames games={popularGames} />
              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Puzzle"
              />

              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Sports"
              />
              <SectionTopUvPlayed topUvPlayedGames={topUvPlayedGames} />

              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Horror"
              />

              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Educational"
              />

              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Casual"
              />

              <Games
                categoryWiseGames={categoryWiseGames}
                categoryName="Android"
              />

              {/* <AndroidGames androidGames={categoryWiseGames} /> */}
            </>
          )}
          <FooterCarousel />

          <Footer />
        </>
      )}

      <Drawer open={open} setOpen={setOpen} />

      {unsubModal && <UnsubModal />}
    </main>
  );
};

export default HomePage;
